import { flexCenter, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { sliderItemHeight } from '../TemplateListWithSlider/Wrapper';

import {
  TemplateVideoPlayerPropsWithoutHandlers,
  TemplateVideoPlayerWithRatioListPositions,
  TemplateVideoPlayerWrapperHeights
} from '.';

const TemplateVideoPlayerWithRatioListAdaptiveStyles = media.tablet`
  height: auto;
  width: 100%;
  position: static;
`;

const TemplateVideoPlayerWrapper = styled.div<
  TemplateVideoPlayerPropsWithoutHandlers
>`
  ${flexCenter};
  flex: 1;
  overflow: hidden;
  min-width: 150px;
  position: relative;
  pointer-events: all;
  img {
    max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : 'unset')};
  }
`;

export const PlayerAndPreviewWrapper = styled.div`
  position: relative;
  z-index: 3;
  max-height: 100%;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const TemplateVideoPlayerWrapperAdaptiveStyles = media.tablet`
  height: auto;
  padding: 0;
  overflow: auto;
`;

const positions: {
  [key in TemplateVideoPlayerWithRatioListPositions]: ReturnType<typeof css>;
} = {
  bottom_buttons: css`
    flex-direction: column-reverse;
    flex: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ul {
      margin-bottom: 0;
      margin-top: 13px;
    }
  `,
  top_buttons: css`
    flex-direction: column;
    margin-bottom: 20px;
    flex: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ul {
      margin-bottom: 20px;
    }
  `
};

const heights: {
  [key in TemplateVideoPlayerWrapperHeights]: ReturnType<typeof css>;
} = {
  video_dependence: css`
    overflow: hidden;
    padding-top: calc(56.25% + 71px);
    height: 0;
    flex: 1;
  `,
  screen_dependence: css`
    height: calc(100vh - 175px);
  `,
  screen_dependence_with_slider: css`
    height: calc(100vh - 175px - ${sliderItemHeight}px);
  `
};

export const TemplateVideoPlayerWithRatioListWrapper = styled.div<
  TemplateVideoPlayerPropsWithoutHandlers
>`
  position: relative;
  pointer-events: none;
  ${TemplateVideoPlayerWrapperAdaptiveStyles};
  ${({ heightDependence }) => [...heights[heightDependence]]};
`;

export const TemplateVideoPlayerWithRatioList = styled.div<
  TemplateVideoPlayerPropsWithoutHandlers
>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ position }) => [...positions[position]]};
  ${TemplateVideoPlayerWithRatioListAdaptiveStyles};
`;

export default TemplateVideoPlayerWrapper;
